import styled from "@emotion/styled";
import { ServerState } from "../../../requests/dataSources/types";

export const StateIndicator = styled.div<{ state: ServerState; size?: number }>`
  width: ${({ size }) => size || "24"}px;
  height: ${({ size }) => size || "24"}px;
  margin: auto;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background-color: ${({ state }) => {
    switch (state) {
      case "online":
        return "green";
      case "offline":
        return "red";
      case "unknown":
        return "#ffd11a";
      default:
        return "#ffd11a";
    }
  }};
`;
